import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CampaignListKind } from '@/enums/campaign-type';

function PageHeader({ kind = 'campaign' }: { kind?: CampaignListKind }) {
  const { t } = useTranslation();
  const isPackageKind = kind === 'package';
  return (
    <>
      <Typography variant="h3" component="h3" gutterBottom>
        {isPackageKind ? t('package.management') : t('campaign.management')}
      </Typography>
      <Typography variant="subtitle2">
        {isPackageKind
          ? t('package.page.subtitle')
          : t('campaign.page.subtitle')}
      </Typography>
    </>
  );
}

export default PageHeader;
